import api from '../../api/api'

// initial state
const state = {
  secret: null,
  requires_action: null,
  error: null,
  status: {
    createPayment: null
  }
}

// getters
const getters = {}

// actions
const actions = {
  createPayment ({ commit, state }, params) {
    commit('setStatus', { createPayment: api.status.PENDING })
    return api.createPayment(params).then((response) => {
      commit('setSuccess', response.data.success)
      commit('setSecret', response.data.payment_intent_client_secret)
      commit('setRequiresAction', response.data.requires_action)
      if (response.data.order)
        commit('order/setOrder', response.data.order, { root: true })
      commit('setStatus', { createPayment: api.status.SUCCESS })
    }).catch((error) => {
      console.log('error!', error.response)
      commit('setError', error.response.data.error)
      commit('setStatus', { createPayment: api.status.FAILURE })
    })
  }
}

// mutations
const mutations = {
  setSecret (state, secret) {
    state.secret = secret
  },
  setRequiresAction (state, requiresAction) {
    state.requiresAction = requiresAction
  },
  setSuccess (state, success) {
    state.success = success
  },
  setError (state, error) {
    state.error = error
  },
  setStatus (state, status) {
    Object.assign(state.status, status)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
